import Timeline from './../timeline/timeline';


export default function Paper(wrapper) {
    Timeline(wrapper.select('.bbc-news-vj-wrapper .timeline__container'));

    return wrapper;
}

